<template>
  <div v-if="apiPrices && defaultPrice">

    <b-card
             class="mb-4"
             :class="productName"
             v-if="vserverC">
      <template v-slot:header >
        <div class="m-3 text-center" >
          <h2>{{productName}}  <i :class="graphic.icon" class="ml-4"></i></h2>
        </div>
      </template>
      <div style="max-width: 220px;" >
        <p>{{description.introduction}}</p>
      </div>
      <h2 v-if="defaultPrice[productKey]">
        <b>{{formatPrice(defaultPrice[productKey].toFixed(1)) }} € / Monat</b>
      </h2>

      <template v-slot:footer>

          <div v-if="!custom" style="margin-left: 42px" >
            <table>
              <tr style="min-width: 280px;">
                <td class="text-right"><b>{{vserverC.cores}}</b></td>
                <td style="min-width: 12px"></td>
                <td>Kerne</td>
              </tr>
              <tr style="min-width: 280px;">
                <td class="text-right" style="min-width: 30px"><b>{{vserverC.memory}} MB</b></td>
                <td style="min-width: 12px"></td>
                <td>RAM</td>
              </tr>
              <tr style="min-width: 280px;">
                <td class="text-right"><b>{{vserverC.disk}} GB</b></td>
                <td style="min-width: 12px"></td>
                <td>Festplatte</td>
              </tr>
              <tr style="min-width: 280px;">
                <td class="text-right"><b>{{vserverC.backups}}</b></td>
                <td style="min-width: 12px"></td>
                <td>Backups</td>
              </tr>
              <tr style="min-width: 280px;">
                <td class="text-right"><b>{{vserverC.addresses_v4}}</b></td>
                <td style="min-width: 12px"></td>
                <td>IP V4 Adressen</td>
              </tr>
            </table>
          </div>

          <div v-if="vserverC && custom" >
            <b-row >
              <b-col>
                <table>
                  <tr v-for="(item, key) in vserver"
                      :key="key"
                      v-if="filter[key]"
                      style="min-width: 280px;">
                    <td class="pr-2">{{ $t('vservers.general')[key] }}</td>
                    <td>
                      <b-form-input
                        :type="filter[key].type"
                        :min="apiPrices[key].min_units"
                        :max="apiPrices[key].max_units"
                        :step="apiPrices[key].step"
                        v-model="vserverC[key]"
                        @input="customChange = true, updateCustomModel()">
                      </b-form-input>
                    </td>
                    <td v-if="key !== 'vserver_template' "
                        style="padding-left:8px; min-width: 80px;">{{item}} {{filter[key].unit}}</td>
                  </tr>
                </table>
              </b-col>
            </b-row>
          </div>
        <div>
          <hr>

        </div>
        <b-row>
          <b-col>Einzelpreis</b-col>
          <b-col>Alle {{productName}}</b-col>
        </b-row>
        <b-row v-if="prices">
          <b-col><h4>{{ formatPrice(prices.single,3)}}</h4> € / Stunde</b-col>
          <b-col><h4>{{ formatPrice((prices.all !== 'NaN' ?prices.all : 0), 3) }}</h4> € / Stunde</b-col>
        </b-row>

        <b-row class="justify-content-center m-4 ">
          <b-link @click="$bvModal.show(productKey)" style="margin:16px;text-decoration:none;" :class="productName"><b >Details</b></b-link>
          <b-modal  :id="productKey">
            <template v-slot:modal-title >
               <h2 class="m-2">{{productName}} <i :class="graphic.icon"></i></h2>
            </template>
            {{description.introduction}}
            PREIS pro Vserver:{{vserverC.price !== 'NaN' ? vserverC.price : 0}} € / Monat
            <template v-slot:modal-footer>
              <div class="m-4">
                {{description.footer}}
              </div>
            </template>
          </b-modal>
        </b-row>
      </template>

    </b-card>
  </div>
</template>

<script>

    import {VserverOrder} from "@/store/models/vserver/vserver_order";
    import {VserverProducts} from "@/mixins/vserver_products";
    import {VserverPrices} from "@/store/models/vserver/vserver_prices";
    import VserverOrderList from "@/store/models/vserver/vserver_order_list";
    import formatPriceMixin from "@/mixins/formatPriceMixin"

    export default {
        name: "luma-create-vserver",
        mixins:[VserverProducts,formatPriceMixin],
        props:{
            prices:Object,
            productName:String,
            productKey:String,
            selected:Boolean,
            apiPrices:Object
        },
        data:()=>({
            vserver: new VserverOrder,
            customChange:false
        }),
        computed:{
            apiPrices(){
                const x = {}
                const y = VserverPrices.all().map(el=>{
                    x[el.unit] = el
                })
                return x
            },
          oslogo(){
            const x = this.vserverC.vserver_template.split('_')
            const logos={
              'UBUNTU':'/static/icons/icons8-ubuntu_filled.svg',
              'DEBIAN': '/static/icons/icons8-debian.svg'
            }
            return logos[x[0]]
          },
            static_product(){
                return VserverProducts
            },
            graphic(){
              return VserverProducts[this.productKey].graphic
            },
            description(){
              return VserverProducts[this.productKey].description
            },
            custom(){
              if(this.productKey === 'custom') return true
            },
            vserverC(){

                if(!this.vserver.cores || this.vserver.price === 0 ) {
                    this.selectProduct(this.productKey)
                }
                return this.vserver
            },
            filter(){
                return {
                    'addresses_v4':{
                        type:'range'
                    },
                    'backups':{
                        type:'range'
                    },
                    'cores':{
                        type:'range',
                        min:1,
                        max:8,
                        unit:''
                    },
                    'memory':{
                        type:'range',
                        min:1024,
                        max:16384,
                        step:1024,
                        unit:'MB'
                    },
                    'disk':{
                        type:'range',
                        min:10,
                        max:250,
                        step:5,
                        unit:'GB'
                    }
                }
            },

            defaultPrice(){
                const data={}
                const ll = Object.keys(VserverProducts).map(el=>
                {

                        const x = VserverProducts[el]
                        const z = ( ((x.cores - this.apiPrices.cores.free_units) / this.apiPrices['cores'].step  * this.apiPrices.cores.price) +
                            ((x.memory - this.apiPrices.memory.free_units)/this.apiPrices['memory'].step * this.apiPrices.memory.price) +
                            ((x.disk - this.apiPrices.disk.free_units)/this.apiPrices['disk'].step * this.apiPrices.disk.price) +
                            ((x.backups - this.apiPrices.backups.free_units)/this.apiPrices['backups'].step * this.apiPrices.backups.price ) +
                            ((x.addresses_v4 - this.apiPrices.addresses_v4.free_units)/this.apiPrices['addresses_v4'].step * this.apiPrices.addresses_v4.price ))
                            data[el]=z
                })
                return data
            },

        },

        methods:{
            updateCustomModel(key){
              //if(this.productKey !== 'custom') return
              VserverOrder.update({where:key,data:this.vserverC})
                if(this.customChange && this.productKey === 'custom'){
                    const ll = JSON.parse(JSON.stringify(VserverOrderList.all()))
                    const l = ll.map((el,index)=>{
                        const newData = Object.assign({},this.vserverC)
                        newData.product_key =  el.product_key
                        newData.$id =  el.$id
                        const product_key = el.product_key.split('-v-')[0] === 'custom' ?
                            VserverOrderList.update({
                                    where:(item)=>{return item.product_key === el.product_key},
                                    data: newData
                               })  :
                            undefined
                    })
            }
              this.customChange = false
              return VserverOrderList.all()
            },
            addToOrder(){
                VserverOrder.insertOrUpdate({data:this.vserverC})
                return
            },
            selectProduct(key){
              if(VserverOrder.find(key)) {
                this.vserver = Object.assign({},VserverOrder.find(key))
                return this.vserver
              }
              if(!VserverOrder.find(key)) this.vserver = VserverProducts[key]
            }
        },
        created() {
            this.defaultPrice[productKey]
        }
    }
</script>

<style scoped>
  .Advanced{
    /*background: grey;*/
    /*color: white;*/
  }
  .Starter{}

  .Advanced{
    color: white;
    background: #343a40;
  }
  .center{
    margin-left: auto;
    margin-right: auto;
    padding-right: auto;
    padding-left: auto;
  }
  .amount{
    background-color: hsla(819, 120%, 10%, 0.1);
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    opacity: 1;
  }
  .card{
    height: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/luma-create-vserver.vue